import { render, staticRenderFns } from "./WsFileDownload.vue?vue&type=template&id=2aee540f"
import script from "./WsFileDownload.vue?vue&type=script&lang=js"
export * from "./WsFileDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports